export default "__VITE_ASSET__wbdDQdso__"